import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { StyledMemberLayout } from './styled'
import FlashType from 'javascripts/layouts/v2/FlashType'

interface MemberLayoutProps {
  children: React.ReactNode;
}

export const MemberLayoutContext = React.createContext({} as {
  flash: FlashType, setFlash: React.Dispatch<React.SetStateAction<FlashType>>
})

const MemberLayout: React.FC<MemberLayoutProps> = (props: MemberLayoutProps) => {
  const [flash, setFlash] = useState<FlashType>()

  useEffect(() => {
    if(flash) {
      const { success, notice, alert, error } = flash
      setFlash({
        success: (success || flash?.success),
        notice: (notice || flash?.notice),
        alert: (alert || flash?.alert),
        error: (error || flash?.error),
      })
    } else {
      setFlash({})
    }
  }, [])

  return (
    <MemberLayoutContext.Provider value={{ flash, setFlash }}>
      <StyledMemberLayout flash={flash}>
        {props.children}
      </StyledMemberLayout>
    </MemberLayoutContext.Provider>
  )
}

const Index: React.FC<MemberLayoutProps> = styled(MemberLayout)`
  background-color: ${props => props.theme.members.colors.lightGreen};
` as React.FC<MemberLayoutProps>

export default Index
